<template>
  <input
    aria-label="Поле ввода скидки в процентах"
    type="text"
    v-bind:disabled="disabled"
    v-bind:value="inputValue"
    v-on:blur="onBlur"
    v-on:focus="isFocused = true"
    v-on:input="onInput"
    class="input-discount"
  />
</template>

<script>

/**
 * @description Название события вода.
 * @type {string}
 */
const NAME_EVENT_INPUT = 'input';

/**
 * @description Название события потери фокуса.
 * @type {string}
 */
const NAME_EVENT_BLUR = 'blur';

/**
 * @description Поле ввода скидки в процентах.
 * @type {Vue}
 */
export default {
  computed: {
    /**
     * @description Значение поля.
     * @returns {string}
     */
    inputValue() {
      if (this.isFocused && this.value === 0) {
        return '';
      }
      const value = this.value.toString();
      if (!this.isFocused && value === '') {
        return '0';
      }
      return value;
    },
  },
  data() {
    return {
      /**
       * @description Фокус на поле.
       * @type {boolean}
       */
      isFocused: false,
    };
  },
  methods: {
    /**
     * @description Отправить событие ввода.
     * @param {number} value
     * @param {boolean} isInvalid
     * @returns {void}
     */
    emitInput(value, isInvalid) {
      this.$emit(NAME_EVENT_INPUT, value);
      if (isInvalid) {
        this.$forceUpdate();
      }
    },
    /**
     * @description Обработать потерю фокуса.
     * @returns {void}
     */
    onBlur() {
      this.isFocused = false;
      this.$emit(NAME_EVENT_BLUR);
    },
    /**
     * @description Обработать ввод.
     * @returns {void}
     */
    onInput(event) {
      const regexp = /\D+/g;
      const inputValue = event.target.value;
      const isInvalid = regexp.test(inputValue);
      const value = isInvalid ? inputValue.replace(regexp, '') : inputValue;
      if (value === '') {
        this.emitInput(0, isInvalid);
        return;
      }
      const percent = Number(value);
      if (percent > 100) {
        this.$forceUpdate();
        return;
      }
      this.emitInput(percent, isInvalid);
    },
  },
  name: 'InputDiscountInPercent',
  props: {
    /**
     * @description Деактивирован.
     * @type {boolean}
     */
    disabled: { default: () => false, type: Boolean },
    /**
     * @description Значение в процентах.
     * @type {number}
     */
    value: { type: Number, required: true },
  },
};
</script>

<style scoped>
.input-discount {
  padding: 5px;
  outline-color: var(--action-color);
  width: 100%;
}
</style>
